// extracted by mini-css-extract-plugin
export default {"container":"vp-z","ratingLayout":"wp-z","ratingLabel":"xp-z","nonInteractiveRatingLabel":"yp-z"};